export default __webpack_public_path__ + "static/media/essenszuschuss.667c18d5.svg";